import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup } from 'semantic-ui-react';
import { fetchAcademicYears, fetchAllAcademicYears } from '../../Lookups/util';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

class NonCycleStudentProgramInformationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nonCycleProgramOptions: [],
            academicYearOptions: [],
            loadingOptions: true,
        };
    }

    componentDidMount() {
        Promise.all([
            axios.get('/non-cycle-programs'),
            fetchAcademicYears(),
        ])
            .then(([programs, academicYears]) => {
                this.setState({
                    nonCycleProgramOptions: programs.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: el.programName,
                        description: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.nonCycleStudyProgramType.translations.length) ? el.nonCycleStudyProgramType.translations.find(e => e.language === window.$locale).name : el.nonCycleStudyProgramType.name),
                    })),
                    academicYearOptions: academicYears.data.map(el => ({
                        key: el.id,
                        value: el,
                        text: ((window.$locale !== 'bs' && window.$locale !== 'hr' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).name : el.name),
                    }))
                        .sort((a, b) => b.text.localeCompare(a.text)),
                    loadingOptions: false,
                });
            });
    }

    render() {
        const {
            nonCycleProgramOptions,
            academicYearOptions,
            loadingOptions,
        } = this.state;
        const {
            onSave,
            onCancel,
            onChangeStudent,
            student,
            errors
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header.Content as="h3">
                            <FormattedMessage id="externalStudent.programInformation"/>
                            {this.props.edit && !loadingOptions && (
                                <Fragment>
                                    <Popup
                                        content={<FormattedMessage id="externalStudent.cancel"/>}
                                        position="top center"
                                        trigger={<Button floated="right" icon="cancel" basic color="red" circular
                                                         size="mini"
                                                         loading={loadingOptions} onClick={onCancel}/>}
                                    />
                                    <Popup
                                        content={<FormattedMessage id="externalStudent.edit"/>}
                                        position="top center"
                                        trigger={<Button floated="right" icon="check" basic color="green" circular
                                                         size="mini"
                                                         loading={loadingOptions} onClick={() => {
                                            onSave(student);
                                        }}/>}
                                    />
                                </Fragment>
                            )}
                        </Header.Content>
                    </Segment>
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.nonCycleProgram"/></label>
                                    <Form.Dropdown
                                        search
                                        options={nonCycleProgramOptions}
                                        value={student.nonCycleProgram || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectNonCycleProgram"/>}
                                        onChange={(e, { value }) => onChangeStudent({ nonCycleProgram: value })}
                                        error={errors.nonCycleProgramErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.programEnrolmentYear"/></label>
                                    <Form.Dropdown
                                        search
                                        options={academicYearOptions}
                                        value={student.academicYear || null}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                        onChange={(e, { value }) => onChangeStudent({ academicYear: value })}
                                        error={errors.academicYearErr}
                                    />
                                </Form.Field>
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default NonCycleStudentProgramInformationForm;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentForms/NonCycleStudentProgramInformationForm.js